import { useFieldHelper } from 'framework/ui/field';
import IconButton from '@mui/material/IconButton';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import { useNewProjectUrl, WASTE_STATUS } from 'domain/shared/newProject';
import { openPageInNewTab } from 'framework/utils';

interface UpdateWasteFieldProps {
  projectId: string;
  statusSource: string;
  idSource: string;
}

const UpdateWasteField = ({ projectId, statusSource, idSource }: UpdateWasteFieldProps) => {
  const { getValue: getStatusValue } = useFieldHelper({ source: statusSource });
  const { getValue: getIdValue } = useFieldHelper({ source: idSource });
  const { getUpdateWasteUrl } = useNewProjectUrl();
  const status = getStatusValue();
  const wasteId = getIdValue();

  return (
    <>
      {status === WASTE_STATUS.DRAFT && (
        <IconButton onClick={() => openPageInNewTab(getUpdateWasteUrl(projectId, wasteId))} data-testid="update-button">
          <AppRegistrationIcon color="primary" />
        </IconButton>
      )}
    </>
  );
};
export default UpdateWasteField;
